'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@/utils/shad';
import { POWER_BAR_DOT_GAP_PX, POWER_BAR_MARKER_LINE_WIDTH, STANDARD_POWER_BAR_LAYOUT, type PowerBarLayout } from '@/domains/pages/shared/power-bar-shared';
type PowerBarDotMarkerProps = {
  position: string;
  layout?: PowerBarLayout;
  lit?: boolean;
  color: string;
  litColor?: string;
  ariaLabel: string;
  className?: string;
  tabIndex?: number;
  onMouseEnter: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
};

/** Vertical tick with a dot below the track — used for selected / top-quartile markers. */
export function PowerBarDotMarker(t0) {
  const $ = _c(20);
  const {
    position,
    layout: t1,
    lit: t2,
    color,
    litColor: t3,
    ariaLabel,
    className,
    tabIndex: t4,
    onMouseEnter,
    onFocus,
    onBlur
  } = t0;
  const layout = t1 === undefined ? STANDARD_POWER_BAR_LAYOUT : t1;
  const lit = t2 === undefined ? false : t2;
  const litColor = t3 === undefined ? "#FFFFFF" : t3;
  const tabIndex = t4 === undefined ? -1 : t4;
  const dotTopPx = layout.trackTopPx + layout.trackHeightPx + POWER_BAR_DOT_GAP_PX;
  const markerColor = lit ? litColor : color;
  let t5;
  if ($[0] !== className) {
    t5 = cn("absolute z-10 w-5 -translate-x-1/2 cursor-pointer bg-transparent p-0", className);
    $[0] = className;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = `${layout.markerHeightPx}px`;
  let t7;
  if ($[2] !== position || $[3] !== t6) {
    t7 = {
      left: position,
      top: 0,
      height: t6
    };
    $[2] = position;
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== markerColor) {
    t8 = <span className="mx-auto block rounded-full transition-colors duration-150" style={{
      width: POWER_BAR_MARKER_LINE_WIDTH,
      height: "100%",
      backgroundColor: markerColor
    }} />;
    $[5] = markerColor;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== dotTopPx || $[8] !== markerColor) {
    t9 = <span className="absolute left-1/2 size-1.5 -translate-x-1/2 rounded-full transition-colors duration-150" style={{
      top: dotTopPx,
      backgroundColor: markerColor
    }} />;
    $[7] = dotTopPx;
    $[8] = markerColor;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== ariaLabel || $[11] !== onBlur || $[12] !== onFocus || $[13] !== onMouseEnter || $[14] !== t5 || $[15] !== t7 || $[16] !== t8 || $[17] !== t9 || $[18] !== tabIndex) {
    t10 = <button type="button" tabIndex={tabIndex} aria-label={ariaLabel} className={t5} style={t7} onMouseEnter={onMouseEnter} onFocus={onFocus} onBlur={onBlur}>{t8}{t9}</button>;
    $[10] = ariaLabel;
    $[11] = onBlur;
    $[12] = onFocus;
    $[13] = onMouseEnter;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
    $[18] = tabIndex;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}